'use es6';

import { forwardRef } from 'react';
import BaseToolbar from './BaseToolbar';
import { EDGE_TOOLBAR_FONT_SIZE, EDGE_TOOLBAR_ICON_SIZE, EDGE_TOOLBAR_LINE_HEIGHT, EDGE_TOOLBAR_HEIGHT } from './constants';
import { jsx as _jsx } from "react/jsx-runtime";
const HorizontalEdgeToolbar = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(BaseToolbar, Object.assign({
  fontSize: EDGE_TOOLBAR_FONT_SIZE,
  iconSize: EDGE_TOOLBAR_ICON_SIZE,
  lineHeight: EDGE_TOOLBAR_LINE_HEIGHT,
  height: EDGE_TOOLBAR_HEIGHT,
  firstButtonRounding: 'top left',
  lastButtonRounding: 'top right'
}, props, {
  forwardedRef: ref
})));
export default HorizontalEdgeToolbar;